import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForYouSection() {
  return;
}